<template>
    <div class="col-12">
      <div class="search-padd">
      <form @change="captureModificationsEvent" v-on:submit.prevent>
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading admin_heading_1 text-align-left">+/-</div>
          <div class="crm_admin_heading mentee_heading_6 text-align-left">First Name</div>
          <div class="crm_admin_heading mentee_heading_6 text-align-left">Last Name</div>
          <div class="crm_admin_heading mentee_heading_15 text-align-left">Email</div>
          <div class="crm_admin_heading mentee_heading_16 text-align-left">Mobile No</div>
          <div class="crm_admin_heading prospect_heading_5 text-align-center">Status</div>
          <div class="crm_admin_heading mentee_heading_14 text-align-center">Contact</div>
          <div class="crm_admin_heading prospect_heading_5 text-align-center">Preferences</div>
          <div class="crm_admin_heading mentee_heading_13 text-align-left">{{ mentor_label_name }}</div>
          <div class="crm_admin_heading mentee_heading_13 text-align-left">Pathway(s)</div>
          <div class="crm_admin_heading mentee_heading_12 text-align-center">&nbsp;</div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-for="(account_mentee, index) in account_mentees">

          <div v-bind:class="'admin_details' + index" v-bind:id="'mentee_details_more' + index">
            <div
              class="crm_admin_field_lists admin_heading_1 text-align-center font-25 line-height-30">
              <a v-b-toggle="'collapse_' + index">
              <span class="when-opened">-</span> <span class="when-closed">+</span>
              </a>
            </div>
            <div class="crm_admin_field_lists mentee_heading_6 text-align-left">
              <div class="search-padd">
              <input
                  type="hidden"
                  v-bind:name="'uid[' + index + ']'"
                  v-bind:id="'uid_' + index"
                  v-model="account_mentee.uid">
                <input
                    type="text"
                    v-bind:id="'mentee_fname_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_fname"
                    v-bind:name="'mentee_fname[' + index + ']'"
                    v-model="account_mentee.mentee_fname"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    placeholder="First Name"
                    maxlength="250">
                <div v-if="verrors.firstByRule('mentee_fname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">First name is required</div>
                <div v-if="verrors.firstByRule('mentee_fname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">First name should only contain - and _</div>
              </div>
              <div class="search-padd" style="width: 155px; margin-top: 2px;">
                <select 
                  class="custom-select" 
                  v-bind:id="'step_assigned_' + index" 
                  v-bind:name="'step_assigned[' + index + ']'"
                  v-model="account_mentee.step_assigned"
                  @focus="getStatusOldValue(index, $event)"
                >
                  <option v-for="(item, index) in account_mentee.steps" :key="index" :value="item.value">{{ item.text }}</option>
                </select>

              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_6 text-align-left">
              <div class="search-padd">
                <input
                    type="text"
                    v-bind:id="'mentee_lname_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_lname"
                    v-bind:name="'mentee_lname[' + index + ']'"
                    v-model="account_mentee.mentee_lname"
                    v-validate="{ rules: { required: true, regex: nameRegex() } }"
                    placeholder="Last Name"
                    maxlength="250">
                <div v-if="verrors.firstByRule('mentee_lname[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Last name is required</div>
                <div v-if="verrors.firstByRule('mentee_lname[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Last name should only contain - and _</div>
              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_15 text-align-left">
              <div class="search-padd">
                <input
                    type="text"
                    v-bind:id="'mentee_email_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_email"
                    v-bind:name="'mentee_email[' + index + ']'"
                    v-model="account_mentee.mentee_email"
                    v-validate="'required|email'"
                    placeholder="Email"
                    autocomplete="off"
                    maxlength="250">
                <div v-if="verrors.firstByRule('mentee_email[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">Email is required</div>
                <div v-if="verrors.firstByRule('mentee_email[' + index + ']', 'email')" class="margin-bottom-5 validate-warning-msg">Email is invalid</div>
                <div v-if="verrors.firstByRule('mentee_email[' + index + ']', 'exists')" class="margin-bottom-5 validate-warning-msg">Email address already exists</div>

              </div>
              <div class="search-padd" style="width: 330px; margin-top: 2px;">
                <div class="form-group row">
                    <div class="col-6">
                    <input
                      type="checkbox"
                      v-bind:id="'future_step_' + index"
                      ref="future_step"
                      v-bind:name="'future_step[' + index + ']'"
                      v-model="account_mentee.future_step"
                      :checked="account_mentee.future_step_checked"
                      @change="mentee_future_step_change(index, $event)"
                      :value="1" style="margin-top: 10px;">
                    <label class="" for="submit_comment_1" style="color: #002F42;">Show future steps</label>
                    </div>
                    <div class="col-6">
                    <input
                      v-if="account_mentee.uid == 0"
                      type="checkbox"
                      v-bind:id="'assign_license_' + index"
                      ref="assign_license"
                      v-bind:name="'assign_license[' + index + ']'"
                      v-model="account_mentee.assign_license"
                      :disabled="account_mentee.assign_license_disabled"
                      @click="mentee_license_assigned(index, $event)"
                      :value="1" style="margin-top: 10px;">
                    <label v-if="account_mentee.uid == 0" class="" for="submit_comment_1" style="color: #002F42;">Assign license</label>
                    </div>
                </div>

              </div>
            </div>
            <div class="crm_admin_field_lists mentee_heading_16 text-align-center">
              <div class="search-padd">
                <input
                    type="text"
                    v-bind:id="'mentee_phone_' + index"
                    class="col-12 col-sm-12 ma-input-field"
                    ref="mentee_phone"
                    v-bind:name="'mentee_phone[' + index + ']'"
                    v-model="account_mentee.mentee_phone"
                    v-validate="{ rules: { regex: phoneRegex() } }"
                    @keyup="phoneValid($event, index)"
                    @blur="phoneValid($event, index)"
                    placeholder="Mobile Number"
                    maxlength="14">
                <div v-if="verrors.firstByRule('mentee_phone[' + index + ']', 'regex')" class="margin-bottom-5 validate-warning-msg">Mobile number is invalid</div>
              </div>
            </div>
            <div class="crm_admin_field_lists prospect_heading_5 text-align-center">
              <div class="search-padd">
                <select 
                  class="custom-select" 
                  v-bind:id="'mentee_status_' + index" 
                  v-bind:name="'mentee_status[' + index + ']'"
                  v-model="account_mentee.mentee_status"
                  @focus="getStatusOldValue(index, $event)"
                  @change="mentee_status_change(index, $event)"
                >
                  <option v-for="(item, index) in user_status_options" :key="index" :value="item.value">{{ item.text }}</option>
                </select>



              </div>



            </div>
            <div class="crm_admin_field_lists mentee_heading_14 text-align-center" style="padding-top: 16px;">
              <div class="search-padd">
                <button class="btn btn-sm ma-blue-btn" @click="openContactModal(index)">Contact</button>
              </div>
              <div v-if="account_mentee.is_transfer_status == 1" class="search-padd" id="mentee-group-wrapper"  style="margin-top: 20px; width: auto; text-align: center;">
                <button class="goal-indicator-btn greenBtn">Transferred</button>
              </div>
              <div class="search-padd" style="margin-top: 10px;" v-if="account_mentee.uid > 0">
                <button class="btn btn-sm ma-blue-btn" @click="openSettingsModal(index)">Settings</button>
              </div>



            </div>
            <div class="crm_admin_field_lists prospect_heading_5 text-align-center" style="padding-top: 16px;">
              <div class="search-padd">
                <button class="btn btn-sm ma-blue-btn" @click="openUserPreferenceModal(index)">Preferences</button>
              </div>


            </div>
            <div class="crm_admin_field_lists mentee_heading_13 text-align-center">
              <div class="search-padd" id="mentee-group-wrapper">
              <multiselect v-model="account_mentee.mentor_assigned"
              :options="mentors" track-by="name" label="name"
              placeholder="Select" :multiple="true"  :close-on-select="false" :show-labels="false"
              @input="captureMultiselectModificationAction(index, 'mentor_assigned', account_mentee.mentor_assigned)"
              @select="toggleSelected($event, index)"
              @remove="toggleRemoved($event, index)"
              v-validate="'required'"
              v-bind:name="'mentor_assigned[' + index + ']'"
              v-bind:id="'mentor_assigned' + index"
              >
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} selected</span></template>
               </multiselect>
             <div v-if="verrors.firstByRule('mentor_assigned[' + index + ']', 'required')" class="margin-bottom-5 validate-warning-msg">{{ mentor_label_name }} is required</div>

              </div>
            </div>

            <div class="crm_admin_field_lists mentee_heading_13 text-align-left">
              <div class="search-padd" id="mentee-tasklist-wrapper">
                <select 
                  class="custom-select" 
                  v-bind:id="'pathway_assigned_' + index" 
                  v-bind:name="'pathway_assigned[' + index + ']'"
                  v-model="account_mentee.pathway_assigned"
                  @focus="getStatusOldValue(index, $event)"
                  @change="mentee_pathway_change(index, $event)"
                >
                  <option v-for="(item, index) in pathways" :key="index" :value="item.value">{{ item.text }}</option>
                </select>
              </div>
            </div>

            <div class="crm_admin_field_lists mentee_heading_12 text-align-center">
              <div class="search-padd delete-icon">
                  <i class="fa fa-window-close cursor-pointer" aria-hidden="true" @click="confirmRemoveMentee(index)"></i>
              </div>
            </div>
          </div>
          <div style="clear: both;"></div>
          <b-collapse v-bind:id="'collapse_' + index" class="">

              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                    <input
                      type="password"
                      v-bind:name="'newpassword[' + index + ']'"
                      v-bind:id="'newpassword_' + index"
                      class="col-12 col-sm-12 ma-input-field"
                      v-model="account_mentee.password"
                      placeholder="Password"
                      v-validate="'min:6'"
                      maxlength="20"
                      role="presentation"
                      autoComplete="new-password"
                      >

                  <div v-show="verrors.has('newpassword[' + index + ']')" class="validate-warning-msg">The password field must be at least 6 characters</div>
                </div>
              </div>

              <div class="col-md-6 float-left override-padding">
                <div class="col-12">
                </div>
              </div>
              <div style="clear: both;"></div>

          </b-collapse>
        <!-- Courses start -->
        <div v-bind:class="'admin_details' + index" v-bind:id="'mentee_details_more' + index">
            <div
              class="course-title">
              <a v-b-toggle="'courses_collapse_' + index">
              Courses <span class="when-opened">-</span> <span class="when-closed">+</span>
              </a>
            </div>
            <b-collapse v-bind:id="'courses_collapse_' + index" @shown="getCoursesInfo(index)">
                <CourseUserResultsHeader
                  :ref="'course_user_results_header_' + index">
                </CourseUserResultsHeader>
            </b-collapse>
        </div>
        <!-- Courses end -->
        <div style="clear: both; margin-top: 10px;"></div>
        </div>
        <button
            v-on:click="addMentee()"
            v-if="account_mentees.length < 50 && account_type == 'Company' "
            class="btn btn-red btn-group-sm"
            >
             <b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>New User</b>
        </button>
        <button
            v-on:click="addMentee()"
            v-if="account_mentees.length < 50 && account_type == 'School'"
            class="btn btn-red btn-group-sm"
            >
             <b><i class="fa fa-plus spacer-icon" aria-hidden="true"></i>New Student</b>
        </button>
        <div style="clear: both;" class="margin-bottom-10"></div>

        <DeleteModal :isModalVisible="isDeleteModalVisible" :id="delete_id" :parent_id="parent_id" @close="isDeleteModalVisible = false">
          <span v-if="loading" class="pull-right text-danger">
            Loading...
          </span>
          <div slot="header" class="sub-heading" v-if="account_type == 'School'">
            Are you sure you want to delete the student?
          </div>
          <div slot="header" class="sub-heading" v-else>
            Are you sure you want to delete the user?
          </div>
          <div slot="body">

          </div>
          <div slot="footer" class="col-3 override-padding">
            <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; deleteMenteeAction(delete_id)">Confirm</button>
          </div>
        </DeleteModal>
        </form>

        <ContactModal 
          :isModalVisible="isContactModalVisible" 
          :id="delete_id" 
          :parent_id="parent_id" 
          @close="isContactModalVisible = false"
          ref="admin_contact_form">
        </ContactModal>

        <MenteeSettingsModal 
          :isModalVisible="isMenteeSettingsModalVisible" 
          @close="isMenteeSettingsModalVisible = false"
          ref="mentee_settings_form">
        </MenteeSettingsModal>

        <UserPreferenceModal 
          :isModalVisible="isUserPreferenceModalVisible" 
          @close="isUserPreferenceModalVisible = false"
          ref="user_preference">
        </UserPreferenceModal>

      </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import DeleteModal from '../shared/delete_modal_alert.vue';
import Multiselect from 'vue-multiselect';
import ContactModal from './admin_contact.vue';
import MenteeSettingsModal from './account_lookup_mentee_settings_modal.vue';
import CourseUserResultsHeader from './course_user_results_header.vue';
import UserPreferenceModal from './account_lookup_user_preference_modal.vue';
import moment from 'moment';
Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
      props: ['accountId', 'program', 'accountStatus'],
      data() {
        return {
          account_mentees: [],
          taskLists: [],
          mentors: [],
          loading: false,
          tasklists_assigned: [],
          mentor_assigned: [],
          isDeleteModalVisible: false,
          parent_id: '',
          delete_id: '',
          mentor_label_name: 'Mentor(s)',
          updated_account_mentees: {},
          account_type: '',
          isContactModalVisible: false,
          isUserPreferenceModalVisible: false,
          mentor_courses: [],
          courses_options: [],
          user_courses: [],
          courses_results: [],
          courses_modules: [],
          usertype_options: [],
          program_label: this.program,
          user_status_options: [
            { value: 'Active', text: 'Active' },
            { value: 'Inactive', text: 'Inactive' },
            { value: 'Prospect', text: 'Prospect' },
            { value: 'No License', text: 'No License' }
          ],
          isMenteeSettingsModalVisible: false,
          old_mentee_status: '',
          mentor_courses: [],
          mentor_assessments: [],
          pathways: [],
          steps: [],
          account_has_license: 0,
          account_has_license_qty: 0,
        }
      },
      components: {
         Multiselect,
         DeleteModal,
         ContactModal,
         CourseUserResultsHeader,
         MenteeSettingsModal,
         UserPreferenceModal,
      },
      methods: {
        nameRegex: function() {
          return /^[\w- ']*$/;
        },
        getStatusOldValue: function(index, event) {
          this.old_mentee_status = this.account_mentees[index].mentee_status;
        },
        mentee_license_assigned: function(index, event) {
          if (event.target.checked) {
            if(this.account_has_license > 0) {
              this.account_mentees[index].assign_license = true;
              this.account_mentees[index].assign_license_disabled = false;      
              this.account_has_license = parseInt(this.account_has_license - 1);
            }
          }
          else {
            this.account_mentees[index].assign_license = false;
            this.account_mentees[index].assign_license_disabled = false;      
            this.account_has_license = parseInt(this.account_has_license + 1);
          }
          
          
        },
        mentee_status_change: function(index, event) {
          if(this.account_mentees[index].mentee_status == 'Active') {
            alert("Master Admin should not change the status to Active. It can be done through Admin Console.");
            this.account_mentees[index].mentee_status = this.old_mentee_status;
            return false;

          }
          
        },
        mentee_pathway_change: function(index, event) {
          this.editpathwaySelected = this.account_mentees[index].pathway_assigned;
          this.mentee_get_steps(index);
        },
        mentee_get_steps: function(index) {
          this.account_mentees[index].steps = [];
          this.account_mentees[index].step_assigned = '';
          this.pathwaySteps = [];
          axios('/get-pathway-steps-name',
            {
              method: 'GET',
              params: {
                pathway_id: this.editpathwaySelected,
              }
            },
          )
          .then(response => {
              this.defaultstep = response.data[0].id;   
              this.pathwaySteps = [];        
              var group = { value: '', text: 'Please select'};
              this.pathwaySteps.push(group); 
              for(var i=0; i < response.data.length; i++) {
                var group = {value: response.data[i].id, text: response.data[i].stepTitle};
                this.pathwaySteps.push(group);
              }
              this.account_mentees[index].steps = this.pathwaySteps;
              this.account_mentees[index].step_assigned = this.defaultstep;
           })
          .catch(error => {

          });

        },
        toggleSelected(item, index) {
          if((this.account_type == 'School') && (this.account_mentees[index].uid == 0)) {
            var groupId = item.value;
            axios.get('/tasklists-group', {
              params: {
                group_id: groupId,
                account_id: this.accountId,
              }
            })
            .then(response => {
                var group_tasklist_assigned = [];
                group_tasklist_assigned = response.data[0].tasklists;
                for(var i=0; i < group_tasklist_assigned.length; i++) {
                  var taskListAddFlag = 0;
                  for(var j=0; j < this.account_mentees[index].tasklists_assigned.length; j++) {
                    if((this.account_mentees[index].tasklists_assigned[j].value == group_tasklist_assigned[i].id)) {
                      taskListAddFlag = 1;
                    }
                  }
                  if(taskListAddFlag == 0) {
                    var tasklistItem = {value: group_tasklist_assigned[i].id, name: group_tasklist_assigned[i].name};
                    this.account_mentees[index].tasklists_assigned.push(tasklistItem);
                  }
                }
             })
            .catch(error => {

            });
          }
        },
        toggleRemoved(item, index) {
          if((this.account_type == 'School') && (this.account_mentees[index].uid == 0)) {
            var groupId = item.value;
            axios.get('/tasklists-group', {
              params: {
                group_id: groupId,
                account_id: this.accountId,
              }
            })
            .then(response => {
                var group_tasklist_assigned = [];
                group_tasklist_assigned = response.data[0].tasklists;
                for(var i=0; i < group_tasklist_assigned.length; i++) {
                  for(var j=0; j < this.account_mentees[index].tasklists_assigned.length; j++) {
                    if((this.account_mentees[index].tasklists_assigned[j].value == group_tasklist_assigned[i].id)) {
                      this.account_mentees[index].tasklists_assigned.splice(j, 1);
                    }
                  }

                }
             })
            .catch(error => {

            });
          }
        },
        addMentee: function() {
          var pathwayId;
          if(this.pathways.length > 1) {
            pathwayId = this.pathways[1].value;
          }
          else {
            pathwayId = '';
          }
          
          this.account_mentees.push({
            uid: 0,
            mentee_fname: '',
            mentee_lname: '',
            mentee_email: '',
            is_enabled: 0,
            is_transfer_status: 0,
            mentee_submit_comment: 0,
            tasklists_assigned: [],
            mentor_assigned: [],
            mentee_courses: [],
            mentee_assessments: [],
            user_type: 'mentee',
            applicable_user_courses: [],
            applicable_user_assessments: [],
            mentee_status: this.getUserStatus(), 
            password: '',
            pathway_assigned: pathwayId,
            step_assigned: '',
            steps: [],
            future_step: false,
            future_step_checked: 0,
            assign_license: false,
            assign_license_disabled: true,
          });
          this.getUserCourses();
          this.getUserAssessments();
          var index = parseInt(this.account_mentees.length - 1);
          this.editpathwaySelected = this.account_mentees[index].pathway_assigned;
          this.mentee_get_steps(index);
          if(this.account_has_license > 0) {
            this.account_mentees[index].assign_license = true;
            this.account_mentees[index].assign_license_disabled = false;      
            this.account_has_license = parseInt(this.account_has_license - 1);
          }
        },
        confirmRemoveMentee: function(index) {
          this.remove_data = this.account_mentees[index];
          this.isDeleteModalVisible = true;
          this.delete_id = index;
        },
        deleteMenteeAction: function(index) {
          if(this.account_mentees[index].uid == 0) {
            this.account_mentees.splice(index, 1);
          }
          else {
            /* Api call to soft delete the user */
            axios('/user/' + this.account_mentees[index].uid + '/' + this.accountId,
               {
                 method: 'DELETE',
               }
             )
            .then((resp) => {
                this.updated_account_mentees = {};
                this.getMenteeListData();
            })
            .catch(error => {

            });
          }
        },
        getMenteeListData: function() {
          if(this.$parent.org_type == 'Company') {
            this.mentor_label_name = 'Mentor(s)';
          }
          else {
            this.mentor_label_name = 'Groups';
          }
          axios("/account_lookup_mentee_list", {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          })
          .then(response => {
            this.loading = false;
            this.account_mentees = response.data.data.account_mentees;
            if(this.account_mentees.length == 0) {
              this.account_mentees.push({
                uid: 0,
                mentee_fname: '',
                mentee_lname: '',
                mentee_email: '',
                mentee_phone: '',
                is_enabled: 0,
                is_transfer_status: 0,
                mentee_submit_comment: 0,
                tasklists_assigned: [],
                mentor_assigned: [],
                mentee_courses: [],
                mentee_assessments: [],
                user_type: 'mentee',
                applicable_user_courses: [],
                applicable_user_assessments: [],
                mentee_status: this.getUserStatus(),
                password: '',
                pathway_assigned: '',
                step_assigned: '',
                steps: [],
                future_step: false,
                future_step_checked: 0,
                assign_license: false,
                assign_license_disabled: true,
              });
              this.getUserCourses();
              this.getUserAssessments();
              if(this.account_has_license > 0) {
                var index = 0;
                this.account_mentees[index].assign_license = true;
                this.account_mentees[index].assign_license_disabled = false;      
                this.account_has_license = parseInt(this.account_has_license - 1);
              }
            }
          })
          .catch(error => {

          });
        },
        captureModificationsEvent ({ type, target }) {
          var regex = /\d+/g;
          var name = target.name;
          var matches = name.match(regex);
          if(this.account_mentees[matches].uid > 0) {
            var value;
            value = target.value;
            if((target.type == 'checkbox') || (target.type == 'radio')) {
              value = target.checked;
            }
            else {
              value = target.value;
            }
            var field = name.replace("["+matches+"]", "");
            if(field == 'mentee_status') {
              //this.old_mentee_status = this.account_mentees[matches].mentee_status;
            }
            var flag = 1;
            if((field == 'mentee_status') && (value == 'Active')) {
              flag = 0;
            }
            if((flag == 1)) {
              this.updateMenteeDetailsEvent(matches, field, value);
            }
          }
        },
        updateMenteeDetailsEvent: function(index, field, value) {
          if(this.account_mentees[index].uid > 0) {
            if(this.updated_account_mentees[index]) {
              if(field == 'pathway_assigned') {
                setTimeout(() => {
                var step_assigned_ele = 'step_assigned_' + index;
                var step_assigned_ele_val = document.getElementById(step_assigned_ele).value;
                Vue.set(this.updated_account_mentees[index], 'step_assigned', step_assigned_ele_val);  
                }, 1000);
              }
              Vue.set(this.updated_account_mentees[index], field, value);
            }
            else {
              this.updated_account_mentees[index] = {};
              Vue.set(this.updated_account_mentees[index], 'uid', this.account_mentees[index].uid);
              if(field == 'pathway_assigned') {
                setTimeout(() => {
                var step_assigned_ele = 'step_assigned_' + index;
                var step_assigned_ele_val = document.getElementById(step_assigned_ele).value;
                Vue.set(this.updated_account_mentees[index], 'step_assigned', step_assigned_ele_val);  
                }, 1000);
              }
              Vue.set(this.updated_account_mentees[index], field, value);
            }
          }
        },
        captureMultiselectModificationAction(index, field, value) {
          if(this.account_mentees[index].uid > 0) {
            if(this.updated_account_mentees[index]) {
              Vue.set(this.updated_account_mentees[index], field, value);
            }
            else {
              this.updated_account_mentees[index] = {};
              Vue.set(this.updated_account_mentees[index], 'uid', this.account_mentees[index].uid);
              Vue.set(this.updated_account_mentees[index], field, value);
            }
          }
        },
        phoneValid: function(event, index) {
            var phone = this.account_mentees[index].mentee_phone;
            this.account_mentees[index].mentee_phone = phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
        },
        phoneRegex: function() {
            return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
        },
        openContactModal: function(index) {
          this.isContactModalVisible = true;
          const vmessage = 'hide_vmessage';
          this.$refs.admin_contact_form.getAdminDetail(this.account_mentees[index], vmessage);
        },
        openUserPreferenceModal: function(index) {
          this.isUserPreferenceModalVisible = true;
          this.$refs.user_preference.first_name = this.account_mentees[index].mentee_fname;
          this.$refs.user_preference.last_name = this.account_mentees[index].mentee_lname;
          this.$refs.user_preference.userId = this.account_mentees[index].uid;
          this.$refs.user_preference.accountId = this.accountId;
          this.$refs.user_preference.getUserPreferenceDetails();
        },
        openSettingsModal: function(index) {
          this.isMenteeSettingsModalVisible = true;
          this.$refs.mentee_settings_form.submit_comment_checked = this.account_mentees[index].mentee_submit_comment;
          this.$refs.mentee_settings_form.index = index;
          this.$refs.mentee_settings_form.getAdminDetail(this.account_mentees[index]);
        },
        checkIsEnabled(index, event) {
            if(event.target.checked == true) {
              this.account_mentees[index].is_enabled = 1;
            } else {
              this.account_mentees[index].is_enabled = 0;
            }
        },
        getCoursesInfo(index) {
          var menteeCourses =  this.account_mentees[index].mentee_courses;
          var courseIds = [];
          for(var i = 0; i < menteeCourses.length; i++) {
            courseIds.push(menteeCourses[i].value);
          }
          var menteeId = this.account_mentees[index].uid;
          this.$refs['course_user_results_header_' + index][0].getCourses(menteeId, courseIds);
        },
        getUserTypeOptions() {
          if (this.program_label == "Mentorship") {
            this.usertype_options = [
              {value: 'mentee', text: 'Mentee'}
            ] 
          } else if (this.program_label == "Apprenticeship") {
            this.usertype_options = [
              {value: 'apprentice', text: 'Apprentice'},
            ] 
          } else {
            this.usertype_options = [
              {value: 'apprentice', text: 'Apprentice'},
              {value: 'mentee', text: 'Mentee'}
            ] 
          }
          for (var j = 0; j < this.account_mentees.length; j++) {
            this.account_mentees[j].user_type = '';
          }
        },
        getUserCourses() {
          var newUserId = this.account_mentees.length - 1;
          var userType = this.account_mentees[newUserId].user_type;
          this.mentor_courses = [];
          axios.get('/account-lookup/course-lists', {
            params: {
              user_roles: (userType == 'apprentice') ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_courses.push(group);
            }
            this.account_mentees[newUserId].applicable_user_courses = this.mentor_courses;

          })
          .catch(function(error) {
            console.log(error);
          });
        },
        getUserAssessments(){
          var newUserId = this.account_mentees.length - 1;
          var userType = this.account_mentees[newUserId].user_type;
          this.mentor_assessments = [];
          axios.get('/account-lookup/assessment-lists', {
            params: {
              user_roles: (userType == 'apprentice') ? 'ROLE_APPRENTICE' : 'ROLE_MENTEE',
              account_id: this.accountId
            },
          })
          .then(response =>  {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].value, name: response.data[i].name};
              this.mentor_assessments.push(group);
            }

            this.account_mentees[newUserId].applicable_user_assessments = this.mentor_assessments;
          })
          .catch(function(error) {
            console.log(error);
          });
        },
        getUserStatus() {
          if (this.$parent.status == "" || this.$parent.status == "Prospect") {
            return "Prospect";
          } else if (this.$parent.status == "Inactive") {
            return this.$parent.status;  
          } else {
            return 'No License';
          }
        }
        
      },
      created: function () {
        this.account_type = this.$parent.org_type;
        this.loading = true;
        axios('/desktop/manager/manage-license',
        {
          method: 'GET',
          params: {
            account_id: this.accountId, 
          }
        })
        .then(resp => {
          this.account_has_license = resp.data.account_has_license;
          this.account_has_license_qty = resp.data.account_has_license;
          this.getMenteeListData();
          
        })
        .catch((error) => {
          
        });
        

        axios('/get-pathway',
          {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          },
        )
        .then(response => {
          var group = { value: '', text: 'Please select'};
          this.pathways.push(group);
          for(var i=0; i < response.data.length; i++) {
            var group = {value: response.data[i].id, text: response.data[i].pathwayName};
            this.pathways.push(group);
          }
        })
        .catch(error => {

        });


        axios('/accountgroups',
          {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
              var group = {value: response.data[i].id, name: response.data[i].groupName};
              this.mentors.push(group);
            }
         })
        .catch(error => {

        });

        axios('/alltasklists-account',
          {
            method: 'GET',
            params: {
              account_id: this.accountId,
            }
          },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
              var tasklistItem = {value: response.data[i].id, name: response.data[i].name};
              this.taskLists.push(tasklistItem);
            }
         })
        .catch(error => {

        });

        axios.get('/account-lookup/course-lists', {
          params: {
            user_roles: 'ROLE_MENTEE',
            account_id: this.accountId
          },
        })
        .then(response =>  {
          for(var i=0; i < response.data.length; i++) {
            var group = {value: response.data[i].id, name: response.data[i].name};
            this.courses_options.push(group);
          }
        })
        .catch(function(error) {
          console.log(error);
        });

        this.getUserTypeOptions();
      },
    }
</script>
<style scoped>
.course-title{ 
  color: #707070;
  font-weight: 900;
}
.course-title a {
  color: #707070;
  text-decoration: none;
}
.admin_heading_1 a {
  color: #707070;
  text-decoration: none;
}
.prospect_heading_5 {
  width: 9%;
}
</style>
<style>
#mentee-tasklist-wrapper li span.multiselect__option--selected span::before,
#mentee-group-wrapper li span.multiselect__option--selected span::before {
  content: '\2713';
  color: #fff;
  background-color: #007bff;
  padding: 3px;
  margin-right: 5px;
}
#mentee-tasklist-wrapper li span.multiselect__option--selected.multiselect__option--highlight,
#mentee-group-wrapper li span.multiselect__option--selected.multiselect__option--highlight {
  background-color: #fff !important;
  color: #212529 !important;
  font-weight: normal !important;
}
.multiselect__option--highlight {
  font-weight: normal !important;
  background-color: #fff !important;
  color: #212529 !important;
}
.multiselect__content-wrapper {
  min-width: 100%;
  width: auto !important;
  border-top: 1px solid #000 !important;
  border: 1px solid #000 !important;
}
.multiselect__option {
  font-size:13px;
}
.multiselect__option--selected {
  font-size: 13px;
  font-weight: normal !important;
}
.mentee_heading_13 {
  width: 14%;
}
.mentee_heading_14 {
  width: 8%;
}
.mentee_heading_15 {
  width: 12%;
}
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}

.multiselect, .multiselect__input, .multiselect__single {
  font-size: 13px;
  font-weight: 400;
  color: #707070;
  background-color: inherit !important;
}
.ma-blue-btn, .ma-blue-btn:focus, .ma-blue-btn:active, .ma-blue-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 36px;
  margin-top: -5px;
}
.mentee_heading_16 {
  width: 10%;
}
.mentee_heading_6 {
  width: 9%;
}
.goal-indicator-btn {
    border-radius: 10px;
    font-size: 13px;
    padding: 5px 15px;
    line-height: 12px;
    height: auto;
    width: 105px;
    text-align: center;
    outline: none !important;
}
.greenBtn, .greenBtn:active, .greenBtn:focus{
    color: #FFFFFF !important;
    background-color: #FF9900 !important;
    border: 1px solid #FF9900 !important;
    cursor: text;
}
.sub-heading {
  color: #002F42;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/components/admin/account_lookup_mentee_tab.vue